export default {
  'menu.welcome': 'Selamat Datang',
  'menu.more-blocks': 'Blocks Lainnya',
  'menu.home': 'Halaman Awal',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Halaman',
  'menu.login': 'Masuk',
  'menu.register': 'Pendaftaran',
  'menu.register-result': 'Hasil Pendaftaran',
  'menu.dashboard': 'Dasbor',
  'menu.dashboard.analysis': 'Analisis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Form Dasar',
  'menu.form.step-form': 'Form Bertahap',
  'menu.form.step-form.info': 'Form Bertahap(menulis informasi yang dibagikan)',
  'menu.form.step-form.confirm':
    'Form Bertahap(konfirmasi informasi yang dibagikan)',
  'menu.form.step-form.result': 'Form Bertahap(selesai)',
  'menu.form.advanced-form': 'Form Lanjutan',
  'menu.list': 'Daftar',
  'menu.list.table-list': 'Tabel Pencarian',
  'menu.list.basic-list': 'Daftar Dasar',
  'menu.list.card-list': 'Daftar Kartu',
  'menu.list.search-list': 'Daftar Pencarian',
  'menu.list.search-list.articles': 'Daftar Pencarian(artikel)',
  'menu.list.search-list.projects': 'Daftar Pencarian(projek)',
  'menu.list.search-list.applications': 'Daftar Pencarian(aplikasi)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Profil Dasar',
  'menu.profile.advanced': 'Profile Lanjutan',
  'menu.result': 'Hasil',
  'menu.result.success': 'Sukses',
  'menu.result.fail': 'Gagal',
  'menu.exception': 'Pengecualian',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Jalankan',
  'menu.account': 'Akun',
  'menu.account.center': 'Detail Akun',
  'menu.account.settings': 'Pengaturan Akun',
  'menu.account.trigger': 'Mengaktivasi Error',
  'menu.account.logout': 'Keluar',
  'menu.editor': 'Penyusun Grafis',
  'menu.editor.flow': 'Penyusun Alur',
  'menu.editor.mind': 'Penyusun Mind',
  'menu.editor.koni': 'Penyusun Koni',

  // 建銀智能評估系統菜單
  'menu.operations': 'Operations Overview',
  'menu.customer': 'Customer Management',
  'menu.customer.customerAdd': 'Add Customer',
  'menu.customer.customerEdit': 'Edit Customer',
  'menu.task': 'Task Management',
  'menu.report': 'Report Management',
  'menu.activity': 'Activity Management',
  'menu.finance': 'Finance Management',
  'menu.platform': 'Platform Maintenance',
  'menu.netValueSolution': 'Net Value Solution',
  'menu.ledger': 'Ledger Management',
  'menu.system': 'System Management',

  // 系統管理子菜單
  'menu.organization': 'Organization Management',
  'menu.logs': 'Operation Logs',
  'menu.user': 'User Management',
  'menu.personal': 'Personal Settings',
  'menu.role': 'Role Management',
  'menu.settings': 'System Settings',

  // 完整的系統管理子菜單路徑
  'menu.system.organization': 'Organization Management',
  'menu.system.logs': 'Operation Logs',
  'menu.system.user': 'User Management',
  'menu.system.userCreate': 'Add User',
  'menu.system.userEdit': 'Edit User',
  'menu.system.personal': 'Personal Settings',
  'menu.system.role': 'Role Management',
  'menu.system.roleCreate': 'Add Role',
  'menu.system.permission': 'Permission Management',
  'menu.system.menu': 'Menu Configuration',
  'menu.system.settings': 'System Settings',

  // 完整的任務管理子菜單路徑
  'menu.task.taskMyTask': 'My Tasks',
  'menu.task.taskStatistics': 'Task Statistics',
  'menu.task.taskSupplement': 'Task Supplement',
  'menu.task.taskCreate': 'Create Task',
  'menu.task.reportReview': 'My Review',
  'menu.task.reportDetail': 'Report Details',

  // 完整的報告管理子菜單路徑
  'menu.report.reportStatistics': 'Report Statistics',
  'menu.report.reportDetail': 'Report Details',

  // Net value solution submenu
  'menu.netValueSolution.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolution.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolution.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolution.netValueSolutionPlanCustomParams':
    'Parameter kustom rencana',
  'menu.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolutionPlanCustomParams': 'Parameter kustom rencana',

  // Ledger submenu
  'menu.ledger.ledgerList': 'Ledger List',
  'menu.ledgerList': 'Ledger List',
  'menu.ledger.ledgerInquiry': 'Inquiry Ledger',
  'menu.ledgerInquiry': 'Inquiry Ledger',
  'menu.ledger.ledgerEdit': 'Edit Ledger',
  'menu.ledgerEdit': 'Edit Ledger',
};
